import { render, staticRenderFns } from "./Bindtips.vue?vue&type=template&id=78f917e9&scoped=true&"
import script from "./Bindtips.vue?vue&type=script&lang=js&"
export * from "./Bindtips.vue?vue&type=script&lang=js&"
import style0 from "./Bindtips.vue?vue&type=style&index=0&id=78f917e9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f917e9",
  null
  
)

export default component.exports